import styled from 'styled-components'
import { iPadDown } from './mediaQueries'

const DesktopOnly = styled.span`
  display: inline-block;
  ${iPadDown} {
    display: none;
  }
`

export default DesktopOnly
